import PropTypes from 'prop-types';
import { CoordinatesShape } from '../../map/models/Coordinates';
import { ContactJoinedShape } from '../../contact/models/contactJoined';

export const Finding = {
  id: PropTypes.number,
  acknowledgedAt: PropTypes.string,
  detectedAt: PropTypes.string,
  timezone: PropTypes.string,
  isWorkzone: PropTypes.bool,
  image: PropTypes.string,
  coordinate: CoordinatesShape,
  creationMode: PropTypes.string,
  priority: PropTypes.string,
  notificationSentAt: PropTypes.string,
  notificationSentTo: PropTypes.string,
  contactJoined: ContactJoinedShape,
  irthExternalId: PropTypes.string,
};

export const FindingShape = PropTypes.shape(Finding);
export const FindingExact = PropTypes.exact(Finding);
